import React from 'react';
import { Bike, Building2, Trees, Mountain, Waves, Droplets, Car, LandPlot } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip";

// Each category renders as a small icon + color-dot pair. Clicking it asks
// the parent to open its customize grid (and optionally jump straight to
// that category's tile) — no more right-side sidebar Sheet.
const ColorLegend = ({
  settings,
  direction = 'horizontal',
  onOpenCategory,
}) => {
  const categoryIcons = {
    activities: { icon: Bike, help: "Activities" },
    land: { icon: LandPlot, help: "Land" },
    buildings: { icon: Building2, help: "Buildings" },
    forests: { icon: Trees, help: "Forests / woods" },
    naturalareas: { icon: Mountain, help: "Parks / reserves" },
    oceans: { icon: Waves, help: "Oceans" },
    water: { icon: Droplets, help: "Water / rivers / lakes" },
    streets: { icon: Car, help: "Roads / paths" },
  };

  const sortedCategories = Object.entries(categoryIcons).sort((a, b) => {
    const isActiveA = settings[a[0]]?.active;
    const isActiveB = settings[b[0]]?.active;
    if (isActiveA && !isActiveB) return -1;
    if (!isActiveA && isActiveB) return 1;
    return 0;
  });

  const renderItem = ([category, { icon: Icon, help }]) => {
    const handleClick = () => {
      if (onOpenCategory) onOpenCategory(category);
    };
    const swatch = (
      <div
        className="relative flex items-center gap-1"
        style={{ opacity: settings[category]?.active ? 1 : 0.15 }}
      >
        <Icon className="h-3 w-3 lg:h-4 lg:w-4" />
        <div
          className="h-3 w-3 lg:h-4 lg:w-4 rounded-full border border-gray-400"
          style={{
            backgroundColor: settings[category]?.color,
            opacity: settings[category]?.alpha,
          }}
        />
        {direction !== 'horizontal' && (
          <p className='text-xs'>{help}</p>
        )}
      </div>
    );
    return (
      <Tooltip key={category}>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={handleClick}
            className="flex items-center gap-1 cursor-pointer hover:opacity-80 transition-opacity bg-transparent border-0 p-0"
          >
            {swatch}
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {!settings[category]?.active ? <><strong>Disabled</strong> - {help}</> : help}
          </p>
        </TooltipContent>
      </Tooltip>
    );
  };

  return (
    <TooltipProvider>
      <div
        className={
          direction === 'horizontal'
            ? "flex flex-wrap items-center justify-center gap-3 mt-4 mb-2"
            : "grid grid-cols-2 lg:grid-cols-1 gap-x-4 gap-y-3 mt-4 mb-2"
        }
      >
        {sortedCategories.map(renderItem)}
      </div>
    </TooltipProvider>
  );
};

export default ColorLegend;
